var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.912,
    height: 27.912,
    viewBox: "0 0 27.912 27.912",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play-circle",
    d: "M14.519.563A13.956,13.956,0,1,0,28.475,14.519,13.954,13.954,0,0,0,14.519.563ZM21.03,15.869l-9.9,5.684a1.353,1.353,0,0,1-2.009-1.182V8.666a1.354,1.354,0,0,1,2.009-1.182l9.9,6.021A1.355,1.355,0,0,1,21.03,15.869Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#6dc1c7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play_circle.50a836e9f8cb12e3e276553d62b5ee10.svg";
export { ForwardRef as ReactComponent };